export default __webpack_public_path__ + "static/media/none_image.db8642ba.svg";